import React, { useContext, useMemo } from "react";
import { inkDataItemInterface } from "../../../types/INK";
import { InkDefaultDataContext } from "../../../WebSocket/WebSocket";
import moduleStyle from '../style.module.css';
import Button from '@mui/material/Button';

import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Checkbox from '@mui/material/Checkbox';

import {socket } from "../../../WebSocket/WebSocket";

// ikony ve stylech
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ReportOutlinedIcon from "@mui/icons-material/ReportOutlined";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import TimelineIcon from "@mui/icons-material/Timeline";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

import moment from "moment/moment";
import { useTypeVariableStore } from "../../../WebSocket/data";
import { Tooltip } from "@mui/material";
import { useTranslation } from 'react-i18next';


interface lineStyleInterface {
  style: {
    line?: React.CSSProperties;
    cell?: React.CSSProperties;
    icon?: any;
  };
  text?: string;
}

export const dataGridLayoutTemplate = "60px 60px 60px 8fr 2.5fr 220px 40px";
export const dataGridLayoutSimulationTemplate = "60px 60px 60px 8fr 2.5fr 220px 100px 40px";


export default function DataBox({
  setClickDataModal,
  election,
  data,
  style = {}
}: {
  setClickDataModal: any;
  election: any;
  data: inkDataItemInterface;
  style?: any;
}) {
  const dataStyle = {
    default: {
      line: {
        backgroundColor: "white",
      },
    },
    quality: {
      line: {
        backgroundColor: "#E859FF",
        fontWeight: "600",
        color: "#810099",
      },
    },
    reserve: {
      line: {
        backgroundColor: "#B1B1B1",
        color: "#5c5c5c",
        fontWeight: "600",
      },
    },
    connect: {
      icon: CompareArrowsIcon,
      line: {
        backgroundColor: "#92ff92",
        color: "#178D46",
        fontWeight: "600",
      },
    },
    disconnect: {
      line: {
        backgroundColor: "#FF0000",
        fontWeight: "600",
        color: "#ffce75",
      },
      icon: CompareArrowsIcon,
    },
    // styl info
    infoOFF: {
      icon: InfoOutlinedIcon,
    },
    // styl aktivní info
    infoON: {
      icon: InfoOutlinedIcon,
      line: {
        backgroundColor: "#92beff",
        color: "#005aff",
        fontWeight: "600",
      },
    },
    // styl měření
    measurement: {
      icon: TimelineIcon,
    },
    // styl aktivní poruchy
    errorON: {
      line: {
        backgroundColor: "#FF0000",
      },
      icon: ReportOutlinedIcon,
    },
    // styl poruchy
    errorOFF: {
      icon: ReportOutlinedIcon,
    },
    // styl aktivní výstrahy
    warningON: {
      line: {
        backgroundColor: "#FFFF00",
        fontWeight: "600",
        color: "#818122",
      },
      icon: WarningAmberIcon,
    },
    // styl výstrahy
    warningOFF: {
      icon: WarningAmberIcon,
    },
    // styl přítomnosti napětí
    voltageON: {
      icon: BoltOutlinedIcon,
      line: {
        fontWeight: "600",
        color: "#ff3737",
      },
    },
    // styl nepřítomnosti napětí
    voltageOFF: {
      icon: BoltOutlinedIcon,
      line: {
        fontWeight: "600",
        color: "#38bb38",
      },
    },
  };
  const ws = useContext(InkDefaultDataContext);
  const [inkSytemDataMaping] = useTypeVariableStore((state) => [state.device[election.deviceIndex]?.inkSytemDataMaping]);
  const { i18n, t } = useTranslation();

  function lineStyleFind(
    style: number,
    value: number,
    en: number,
    quality: number,
    typ: number
  ) {
    const testStyle = ws[election.deviceIndex].graphics;

    let nameStyl, text;
    //console.log("test stylu",testStyle[style], style, value);
    if (testStyle[style]?.item) {
      if (testStyle[style].item[value]) {
        nameStyl = testStyle[style].item[value]?.style;
        text = testStyle[style].item[value]?.name;
      }
    }

    let styleLine: any = {};

    //@ts-ignore
    if (nameStyl === undefined || dataStyle[nameStyl] === undefined) {
      styleLine = dataStyle["default"];
    } else {
      //@ts-ignore
      styleLine = dataStyle[nameStyl];
    }

    if (typ === 7 || typ === 8 || typ === 9 || typ === 27 || typ === 28) {
      styleLine = dataStyle.measurement;
    }
    if (quality === 1) {
      if (en === 0) {
        styleLine.line = dataStyle.reserve?.line;
        //console.log("reserve", typ);
      } else {
        styleLine.line = dataStyle.quality?.line;
      }
    } else if (en === 0) {
      styleLine.line = dataStyle.reserve?.line;
      //console.log("reserve", typ);
    }

    return {
      style: styleLine,
      text: text,
    };
  }

  function selectionTime() {
    switch (election.time) {
      case 0:
        return data.value.time;
      case 1:
        return moment(data.value.time / 1000000).format(
          ws[election.deviceIndex]?.timeFormat?.time
        );
      case 2:
        return (
          "UTC: " +
          moment
            .utc(data.value.time / 1000000)
            .format(ws[election.deviceIndex]?.timeFormat?.timeUTC)
        );
      default:
        return "Error";
    }
  }
  //console.log("vypis dat", data)
  const lineStyle: lineStyleInterface = useMemo(
    () =>
      lineStyleFind(data.xmlConfig.style, inkSytemDataMaping?.ink_test ? data.value.value_t : data.value.value, data.inkConfig.en, inkSytemDataMaping?.ink_test ? (data.value.quality_t || 0) : data.value.quality, data.inkConfig.typ),
    [data.value.value, data.value.quality, data.value.value_t, data.value.quality_t]
  );

  return (
    <div
      style={{
        ...style,
        ...lineStyle.style.line,
        display: "grid",
        gridTemplateColumns: inkSytemDataMaping?.ink_test === 1 ? dataGridLayoutSimulationTemplate : dataGridLayoutTemplate,
        // alignItems: "center",
      }}
      className={moduleStyle.dataBox}
    >
      <div>{data.inkConfig.id}</div>
      <div>{lineStyle.style.icon ? <lineStyle.style.icon /> : null}</div>
      <div>
        {data.value?.isInit === 0 && 
          <Tooltip title="Chyba inicializace" arrow placement="top">
            <PriorityHighIcon/>
          </Tooltip>
        }
        {data.value?.isInit === 1 && 
          <Tooltip title="Nebylo inicializováno" arrow placement="top">
            <QuestionMarkIcon/>
          </Tooltip>
        }
      </div>
      <div>
        <span style={{ cursor: "pointer" }} onClick={() => {
          setClickDataModal({
            deviceIndex: election.deviceIndex,
            index: data.inkConfig.id,
            open: true,
          });
        }}>{data.inkConfig.desc}</span>
        
      </div>
      <div style={lineStyle.style.cell}>
        {lineStyle.text ? lineStyle.text : (inkSytemDataMaping?.ink_test ? data.value.value_t : data.value.value)}
      </div>
      <div>{selectionTime()}</div>
      {inkSytemDataMaping?.ink_test === 1 && (
        <div style={lineStyle.style.cell}>
          {data.inkConfig.typ === 1 || data.inkConfig.typ === 2 || data.inkConfig.typ === 3 || data.inkConfig.typ === 4 || data.inkConfig.typ === 5 ?
            <React.Fragment>
              <Button style={{ padding: "3px" }} variant="contained" onClick={() => { comandRewrite(data.inkConfig.typ, data.value.value_t) }}>
                {data.value.value_t === 1 ? "Nepůsobit" : "Působit"}
                  {/*//t("has-effect") : t("has-no-effect")}*/}
              </Button>
            </React.Fragment>
            : ""}
          {data.inkConfig.typ === 6 ?
            <React.Fragment>
              <Button style={{ padding: "3px" }} variant="contained" onClick={() => { comandRewrite(data.inkConfig.typ, data.value.value_t) }}>
                {data.value.value_t === 2 ? "vypnout" : "zapnout"} 
                {/*//t("turned-on") : t("turned-off")}*/}
              </Button>
            </React.Fragment>
            : ""}
        </div>
      )}
      <div>
        <IconButton
          onClick={() => {
            setClickDataModal({
              deviceIndex: election.deviceIndex,
              index: data.inkConfig.id,
              open: true,
            });
          }}
        >
          <MoreHorizIcon />
        </IconButton>
      </div>
      {/* <div>
        <Checkbox checked={data.checked} style={{ padding: "0px 0px 0px 2px"}} />
      </div> */}
    </div>
  );

  function comandRewrite(dataType: number, currentValue: number) {
    if (dataType === 1 || dataType === 2 || dataType === 3 || dataType === 4 || dataType === 5) { //pusobí/nepusobí
      if (currentValue === 1) comandRewriteValue(0)
      else comandRewriteValue(1);
    }
    else if (dataType === 6) { //zapnuto/vypnuto
      if (currentValue === 2) comandRewriteValue(1)
      else comandRewriteValue(2);
    }

  }

  function comandRewriteValue(value: number) {
    socket[election.deviceIndex].emit("command", {
      messageID: 5,
      messageType: "rewrite",
      data: [
        {
          id: data.inkConfig.id,
          quality: 0,
          value: value, 
        },
      ],
    });
    

  }


}
